import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";

import Profile from "../views/Profile.vue";
import Signin from "../views/Signin.vue";
import Membres from "../views/Membres.vue";
import Duraciones from "../views/Duraciones.vue";
import Users from "../views/Usuario/Users.vue";
import UsuariosCrear from "../views/Usuario/UserCreatePage.vue";
import UsuariosEdiar from "../views/Usuario/UserEditPage.vue";
import SocioDetalle from "../views/Socios/SocioDetallePage.vue";
import Acceso from "../views/RegistrarAsistenciaPublic.vue";
import Asistencia from "../views/Asistencias.vue";
import Pagos from "../views/Pagos.vue";
import DashboardMembresias from '../views/DashboardMembresias.vue';
import EmpresaConfig from '../views/ConfigEmpresa/ConfigEmpresaPage.vue';
import { hasPermission } from "@/composables/useAuth";

const routes = [
  {
    path: "/",
    redirect: () => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      const hasSession = !!(token && refreshToken);
      return hasSession ? '/dashboard-default' : '/signin';
    },
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, permission: "dashboard.ver" },
  },
  {
    path: "/membres",
    name: "Membres",
    component: Membres,
    meta: { requiresAuth: true, permission: "membresias_catalogo.ver" },

  },
  {
    path: "/duraciones",
    name: "Duraciones",
    component: Duraciones,
    meta: { requiresAuth: true, permission: "membresias_catalogo.ver" },

  },
  {
    path: "/users",
    name: "Socios",
    component: Users,
    meta: { requiresAuth: true, permission: "socios.ver" },

  },

  {
    path: "/users/nuevo",
    name: "UsuarioCrear",
    component: UsuariosCrear,
    meta: { requiresAuth: true, permission: "socios.gestionar" },
  },
  {
    path: "/users/editar/:id",
    name: "UsuarioEditar",
    component: UsuariosEdiar,
    meta: { requiresAuth: true, permission: "socios.gestionar" },
    props: true
  },
  {
    path: '/socios/:id',
    name: 'SocioDetalle',
    component: SocioDetalle,
    meta: { requiresAuth: true, permission: "socios.ver" },
    props: true
  },
  {
    path: '/dashboard/membresias',
    name: 'DashboardMembresias',
    component: DashboardMembresias,
    meta: { requiresAuth: true, permission: "membresias_socios.ver" }
  },
  {
    path: "/asistencias",
    name: "Asistencias",
    component: Asistencia,
    meta: { requiresAuth: true, permission: "asistencias.ver" },
  },
  {
    path: "/pagos",
    name: "Pagos",
    component: Pagos,
    meta: { requiresAuth: true, permission: "pagos.ver" },
  },
  {
    path: "/config/empresa",
    name: "EmpresaConfig",
    component: EmpresaConfig,
    meta: { requiresAuth: true, permission: "config_empresa.gestionar" },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true, permission: "perfil.propio" },
  },
  {
    path: "/signin",
    name: "signin",
    component: Signin,
  },
  {
    path: '/registrar-acceso',
    name: 'RegistrarAsistenciaPublic',
    component: Acceso,
    meta: { requiresAuth: false } // importante que no requiera token
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/signin'
  }
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  linkActiveClass: "active",
});

function hasSession() {
  const token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refreshToken');
  return !!(token && refreshToken);
}

function isSocioLocal() {
  try {
    const raw = localStorage.getItem('user');
    const u = raw ? JSON.parse(raw) : null;
    const rolStr = typeof u?.rol === 'string' ? u.rol : (u?.rol?.nombre || '');
    return String(rolStr || '').trim().toUpperCase() === 'SOCIO';
  } catch { return false; }
}

router.beforeEach((to, from, next) => {
  const session = hasSession();

  // SOCIO nunca debe entrar al panel aunque haya token manipulado
  if (session && isSocioLocal() && to.meta.requiresAuth) {
    return next("/signin");
  }

  if (to.meta.requiresAuth && !session) {
    return next("/signin");
  }

  if (session && to.path === "/signin") {
    return next("/dashboard-default");
  }

  // Chequeo por permiso
  if (to.meta.permission) {
    if (!session) return next("/signin");
    if (!hasPermission(to.meta.permission)) {
      // Redirigir a dashboard si tiene dashboard.ver, si no a signin/profile según permisos
      if (hasPermission("dashboard.ver")) return next("/dashboard-default");
      if (hasPermission("perfil.propio")) return next("/profile");
      return next("/signin");
    }
  }

  return next();
});


export default router;
